<app-navigation></app-navigation>
<main>
  <router-outlet></router-outlet>
</main>
<div id="cursor" [ngClass]="{ hidden: !this.config.modalities[1].active }"></div>
<div id="image-cursor"></div>
<div id="message-box"></div>
